import { Navigate, useParams } from 'react-router';
import { DisplayType, NotificationType, useGetNotificationQuery } from '../../../../../../generated/core-api/graphql-react-query';
import useProjectIdContext from '../../../../../Contexts/ProjectContexts/ProjectIdContext/useProjectIdContext';

export default function NotificationPage() {
  const { id } = useParams<'id'>();
  const notification = useGetNotificationQuery({ id: id || '' });
  const { setProjectId, projectId } = useProjectIdContext();
  if (notification.isLoading) {
    return <div>Loading...</div>;
  }

  if (notification.isError) {
    return <div>Error</div>;
  }

  if (!notification.data) {
    return <div>Not found</div>;
  }

  const notif = notification.data.getNotification;

  switch (notif.event.eventType) {
    case NotificationType.NewContent:
      setProjectId(notif.event.projectId);
      return <Navigate to={`/projects/${notif.event.projectId}/cards/${notif.event.cardId}`} />;
    case NotificationType.ProjectAssigned:
      setProjectId(notif.event.projectId);
      return <Navigate to="/home" />;
    case NotificationType.CardComment:
      if (notif.event.card?.scopes.items && notif.event.card?.scopes.items.length > 0) {
        const currentProjectId = notif.event.card?.scopes.items.find((p) => p.projectId === projectId)?.projectId;
        const newProjectId = currentProjectId ?? notif.event.card?.scopes.items[0].projectId;
        if (newProjectId) {
          if (!currentProjectId) {
            setProjectId(newProjectId);
          }
          return <Navigate to={`/projects/${newProjectId}/cards/${notif.event.cardId}?displayType=${DisplayType.CardLink}`} />;
        }
      }
      throw new Error('Card not found');
    case NotificationType.AvailableCommand:
      setProjectId(notif.event.projectId);
      return <Navigate to={`/commands?search=${notif.event.command.text}`} />;

    case NotificationType.ContentRequestCommented:
    case NotificationType.ContentRequestCreated:
    case NotificationType.ContentRequestUpdated:
      return <Navigate to={`/requests/${notif.event.contentRequestCounter}`} />;

    default:
      return <div>Not found</div>;
  }
}
